/** 仅按正式状态码识别并发冲突，不根据服务端提示文本猜测是否可重试。 */
export function isMyIpVersionConflict(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const value = error as { status?: number; code?: number | string; response?: { status?: number; data?: { code?: number | string; }; }; };
  const code = value.code ?? value.response?.data?.code;
  // 15501 为旧兼容码；15606 为 IP CAS / 角色卡任务绑定正式冲突码。
  return value.status === 409 || value.response?.status === 409
    || code === 15501 || code === 15606 || code === 'version_conflict';
}
